module.exports = __webpack_public_path__ + "img/how1.9654de40.svg";